import { Button, TextField, Box, Typography } from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { SubscriptionModel } from 'types'
import axios from 'axios'

const initialSubscription: Omit<SubscriptionModel, 'id' | 'nbOfSubscribers'> = {
  name: '',
  price: 0,
  maxProfiles: 0,
  maxLicenses: 0,
}

export default function SubscriptionCreatePage() {
  const navigate = useNavigate()
  const [subscription, setSubscription] = useState(initialSubscription)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setSubscription((prev) => ({
      ...prev,
      [name]: name === 'name' ? value : Number(value),
    }))
  }

  const handleSubmit = () => {
    const token = localStorage.getItem('token')
    axios
      .post(base_url + `/subscription/`, subscription, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => navigate(`/subscriptions`))
      .catch((error) =>
        alert('La création a échoué: ' + error.response?.data?.message)
      )
  }

  return (
    <PageAppBar pageName="Créer un Abonnement">
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          alignItems: 'center',
          padding: '2rem',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h5">Nouvel Abonnement</Typography>
        <TextField
          required
          fullWidth
          name="name"
          label="Nom de l'abonnement"
          value={subscription.name}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="price"
          label="Prix"
          type="number"
          value={subscription.price}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="maxProfiles"
          label="Nombre max de profils"
          type="number"
          value={subscription.maxProfiles}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="maxLicenses"
          label="Nombre max de licences"
          type="number"
          value={subscription.maxLicenses}
          onChange={handleChange}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          sx={{ mt: 2 }}
        >
          Créer
        </Button>
      </Box>
    </PageAppBar>
  )
}
